<template>
  <div class="watermark-editor">
    <div class="container">
      <div class="control-panel">
        <div class="watermark-list">
          <button @click="triggerFileInput">上传图片</button>
          <input
            type="file"
            id="image-upload"
            accept="image/*"
            @change="handleImageUpload"
            style="display: none"
          >
        </div>
        <div class="watermark-list">
          <div class="header">水印列表</div>
          <div class="list-container">
            <div
              v-for="(mark, index) in markList"
              :key="index"
              class="watermark-item"
              :class="{ active: actIndex === index }"
              @click="setActiveWatermark(index)"
            >
              <span class="copy" @click.stop="copyWatermark(index)">
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAkCAYAAACe0YppAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsIAAA7CARUoSoAAAAARdEVYdFNvZnR3YXJlAFNuaXBhc3RlXRfO3QAAAlxJREFUWEftmE+LsVEUwM/DO4NsKBZKiZgmlFmIpOxkZWvF1ndQyixkwYr4Ej6DpY1moSSF2BBJIgn5MzPvOS6v52Xm7fXnWc2vrnPPeW6de849T8+5uI/fwBGvr68ka7UayVsjFovB5XKBiOmCsd1uoVQqCe8YWa/XwEt1LpeD0WgE7+/vh1Tn83mStyASiUCr1aI5RYwO8WyHwyE5FQIum81+oENkuVySRNrtNkmDwUDyErCQPB4P+Hw+0o8j5mKxGKW61+vBZDIh4y3R6XSQSqVofpJqBKvtHqxWKzbj8wt/rFYrdDodMlgsFgiHwzS/lNlsBplMBgaDAbOcQhFXq1VSEKlUChqN5qqhUqlAJPr+TaWnarUa5HI5GYRChBFiVSuVSmYSBtH+FeI4jqRQHA4CC0JIDo7H4zGbCcP3pXdHfhwLxo9jwfhxLBgnjvGjgU3BuTGfz9mq66EO5JhGowHRaJRpfLxeLwSDQaZdB0WM3eAebLYXi8XZ8fb2xlZdDznGRs9kMpFhj81mo+hCoRD1YbfmcMZ4tmazmTagUCio3X1+fga/3w9PT09s1f/T7/chEAjQ2Le2yElxPTw8UMOG7VAymaQzv8ftQoSF9PLywtQd2AZh1NPpFNLpNDSbTfbkdvAubfF4HDabDdNO78iYCdzIv8BuBu9imGa9Xg8ymYw92WG32/mOi8UiFAoFpgFIJBIol8tM2x2DVquFx8dHZjkP3h663S69IV9t9st/BBC32w2VSoUu0pdiNBohkUgw7Q8njv9Ot8PhgHq9ThFcgtPppIrmA/AJMuUXSMZa8pgAAAAASUVORK5CYII=">
              </span>
              <span class="text">{{ mark.watermarkText || '新水印' }}</span>
              <span class="delete" @click.stop="deleteWatermark(index)">×</span>
            </div>
          </div>
          <button @click="addWatermark">+ 添加水印</button>
        </div>

        <div class="control-group">
          <label for="font-family">字体选项</label>

          <div class="font-family-container">
            <select id="font-family" v-model="activeWatermark.fontFamily">
              <option v-for="font in availableFonts" :key="font" :value="font">{{ font }}</option>
            </select>
            <div class="font-family-input-box">
              <input
                type="text"
                v-model="newFontFamily"
                placeholder="输入字体名称"
                @keyup.enter="addAndSelect"
              >
              <button @click="addAndSelect">添加并选择</button>
            </div>
          </div>
          <select id="font-repeat" v-model="activeWatermark.repeatMode" @change="resetOffset">
            <option v-for="rep in repOpt" :key="rep.value" :value="rep.value">{{ rep.label }}</option>
          </select>
          <input
            type="color"
            id="watermark-color"
            v-model="activeWatermark.watermarkColor"
          >
        </div>

        <div class="control-group">
          <label for="opacity">透明度 ({{ activeWatermark.opacity }}%)</label>
          <input
            type="range"
            id="opacity"
            min="0"
            max="100"
            v-model.number="activeWatermark.opacity"
          >
        </div>

        <div class="control-group">
          <label for="rotation-angle">旋转角度 ({{ activeWatermark.rotationAngle }}°)</label>
          <div class="rotation-angle-input-box">
            <span class="icon" @click.stop="stepRotation(-1)">{{ '<' }}</span>
            <input
              type="range"
              id="rotation-angle"
              min="-180"
              max="180"
              step="5"
              v-model.number="activeWatermark.rotationAngle"
            >
            <span class="icon" @click.stop="stepRotation(1)">{{ '>' }}</span>
          </div>
        </div>

        <div class="control-group">
          <div v-if="activeWatermark.repeatMode == 'repeat' || activeWatermark.repeatMode == 'repeat-x'">
            <label for="horizontal-spacing">水平间距 ({{ activeWatermark.horizontalSpacing }}px)</label>
            <input
              type="range"
              id="horizontal-spacing"
              min="-400"
              :max="Math.max(activeWatermark.horizontalSpacing * 1.1, 500)"
              v-model.number="activeWatermark.horizontalSpacing"
            >
            <input
              type="number"
              style="width: 90%"
              v-model.number="activeWatermark.horizontalSpacing"
            >
          </div>
          <div v-if="activeWatermark.repeatMode == 'repeat' || activeWatermark.repeatMode == 'repeat-y'">
            <label for="vertical-spacing">垂直间距 ({{ activeWatermark.verticalSpacing }}px)</label>
            <input
              type="range"
              id="vertical-spacing"
              min="-400"
              :max="Math.max(activeWatermark.verticalSpacing * 1.1, 500)"
              v-model.number="activeWatermark.verticalSpacing"
            >
            <input
              type="number"
              style="width: 90%"
              v-model.number="activeWatermark.verticalSpacing"
            >
          </div>
        </div>
      </div>

      <div class="right-panel">
        <div class="header">
          <div class="label">编辑水印:</div>
          <input
            type="text"
            id="watermark-text"
            placeholder="输入水印文字"
            v-model="activeWatermark.watermarkText"
          >
          <button @click="downloadImage">下载图片</button>
        </div>

        <div class="canvas-container">
          <canvas
            ref="canvas"
            @mousedown="startDrag"
            @mousemove="doDrag"
            @mouseup="stopDrag"
            @mouseleave="stopDrag"
            @wheel.prevent="handleWheel"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WatermarkEditor',
  data() {
    return {
      markList: [
        {
          watermarkText: '仅用于办理XXXX，他用无效。',
          fontSize: 30,
          opacity: 80,
          watermarkColor: '#646464',
          offsetX: 0,
          offsetY: 0,
          rotationAngle: -45,
          fontFamily: '黑体',
          repeatMode: 'repeat',
          horizontalSpacing: 30,
          verticalSpacing: 30
        }
      ],
      actIndex: 0,
      currentImage: null,
      ctx: null,
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      rect: {},
      newFontFamily: '',
      renderPending: false,
      patternCache: new Map(),
      availableFonts: [
        '黑体',
        '宋体',
        '楷体',
        '仿宋',
        '微软雅黑',
        '华文行楷',
        '华文琥珀',
        'Times New Roman',
        'Impact'
      ],
      repOpt: [
        { label: '平铺', value: 'repeat' },
        { label: '水平平铺', value: 'repeat-x' },
        { label: '垂直平铺', value: 'repeat-y' },
        { label: '不重复', value: 'no-repeat' }
      ]
    };
  },
  computed: {
    activeWatermark() {
      return this.markList[this.actIndex] || {};
    }
  },
  mounted() {
    this.initCanvas();
  },
  watch: {
    markList: {
      handler() {
        this.renderCanvas();
      },
      deep: true
    }
  },
  methods: {
    initCanvas() {
      const canvas = this.$refs.canvas;
      canvas.width = 800;
      canvas.height = 500;
      this.ctx = canvas.getContext('2d');
      this.renderCanvas();
    },
    copyWatermark(index) {
      const copied = JSON.parse(JSON.stringify(this.markList[index]));
      this.markList.push(copied);
      this.actIndex = this.markList.length - 1;
    },
    stepRotation(act) {
      const angle = this.markList[this.actIndex].rotationAngle;

      // 确保输入角度在-180~180范围内（处理异常值）
      let normalizedAngle = angle;
      if (angle > 180 || angle < -180) {
        normalizedAngle = ((angle % 360) + 540) % 360 - 180;
        if (normalizedAngle === -180) normalizedAngle = 180;
      }

      // 确定步进方向（正数为顺时针增加角度）
      const step = act > 0 ? 1 : -1;

      // 计算目标角度（按45度倍数的方向步进）
      let targetAngle;
      if (step > 0) {
        targetAngle = Math.ceil(normalizedAngle / 45) * 45;
        // 处理180度边界情况（180+45=225 等价于 -135）
        if (targetAngle - normalizedAngle === 0) targetAngle += 45;
      } else {
        targetAngle = Math.floor(normalizedAngle / 45) * 45;
        // 处理-180度边界情况（-180-45=-225 等价于 135）
        if (normalizedAngle - targetAngle === 0) targetAngle -= 45;
      }

      // 标准化结果到-180~180范围
      let result = targetAngle % 360;
      if (result > 180) result -= 360;
      if (result <= -180) result += 360;

      // 处理特殊边界值（180和-180等效）
      if (result === -180) result = 180;

      // 更新旋转角度
      this.markList[this.actIndex].rotationAngle = result;
    },
    addAndSelect() {
      if (!this.newFontFamily.trim()) {
        return;
      }

      // 防止重复添加
      if (!this.availableFonts.includes(this.newFontFamily)) {
        this.availableFonts.push(this.newFontFamily);
      }

      this.markList[this.actIndex].fontFamily = this.newFontFamily;

      this.newFontFamily = '';
    },
    resetOffset() {
      this.markList[this.actIndex].offsetX = 0
      this.markList[this.actIndex].offsetY = 0
    },
    triggerFileInput() {
      document.getElementById('image-upload').click();
    },

    handleImageUpload(e) {
      const file = e.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.onload = () => {
          this.currentImage = img;
          this.renderCanvas();
        };
        img.src = event.target.result;
      };
      reader.readAsDataURL(file);
    },

    addWatermark() {
      this.markList.push({
        watermarkText: '新水印',
        fontSize: 30,
        opacity: 80,
        watermarkColor: '#646464',
        offsetX: 0,
        offsetY: 0,
        rotationAngle: -45,
        fontFamily: '黑体',
        repeatMode: 'no-repeat',
        horizontalSpacing: 30,
        verticalSpacing: 30
      });
      this.actIndex = this.markList.length - 1;
    },

    setActiveWatermark(index) {
      this.actIndex = index;
    },

    deleteWatermark(index) {
      if (this.markList.length <= 1) {
        alert('至少需要保留一个水印');
        return;
      }

      this.markList.splice(index, 1);
      if (this.actIndex >= index) {
        this.actIndex = Math.max(0, this.actIndex - 1);
      }
    },

    createWatermarkPattern(mark) {
      const cacheKey = `${mark.watermarkText}-${mark.fontSize}-${mark.repeatMode}-${mark.rotationAngle}-${mark.opacity}-${mark.watermarkColor}-${mark.fontFamily}-${mark.horizontalSpacing}-${mark.verticalSpacing}`;

      if (this.patternCache.has(cacheKey)) {
        return this.patternCache.get(cacheKey);
      }

      const text = mark.watermarkText || ' ';
      const fontSize = mark.fontSize;
      const rotationDegrees = mark.rotationAngle;
      const rotate = rotationDegrees * Math.PI / 180;
      const color = mark.watermarkColor;
      const alpha = mark.opacity / 100;

      // 解析颜色值
      const r = parseInt(color.slice(1, 3), 16);
      const g = parseInt(color.slice(3, 5), 16);
      const b = parseInt(color.slice(5, 7), 16);

      const patternCanvas = document.createElement("canvas");
      const patternCtx = patternCanvas.getContext("2d");

      // 设置临时字体进行测量
      patternCtx.font = `${fontSize}px "${mark.fontFamily}", 黑体`;

      // 测量文本
      const textMetrics = patternCtx.measureText(text);
      const textWidth = textMetrics.width;


      if (mark.repeatMode === 'no-repeat') {
        patternCanvas.width = textWidth + 20;
        patternCanvas.height = textWidth + 20;
      } else {
        patternCanvas.width = textWidth + mark.horizontalSpacing;
        patternCanvas.height = textWidth + mark.verticalSpacing;
      }

      // 设置实际绘制参数
      patternCtx.fillStyle = `rgba(${r}, ${g}, ${b}, ${alpha})`;
      patternCtx.textAlign = 'center';
      patternCtx.textBaseline = 'middle';
      patternCtx.font = `${fontSize}px "${mark.fontFamily}", 黑体`;

      // 移动到画布中心
      patternCtx.translate(patternCanvas.width / 2, patternCanvas.height / 2);
      patternCtx.rotate(rotate);
      patternCtx.fillText(text, 0, 0);

      // 缓存结果
      this.patternCache.set(cacheKey, patternCanvas);
      return patternCanvas;
    },

    renderCanvas() {
      const canvas = this.$refs.canvas;
      const ctx = this.ctx;

      if (!this.currentImage) {
        // 绘制默认背景
        canvas.width = 800;
        canvas.height = 500;
        ctx.fillStyle = '#f0f0f0';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.fillStyle = '#999';
        ctx.font = '20px 黑体';
        ctx.textAlign = 'center';
        ctx.fillText('上传图片后，水印效果将显示在这里', canvas.width/2, canvas.height/2);
        return;
      }

      // 调整画布大小以适应图片
      const maxWidth = 4000;
      const maxHeight = 3000;
      let width = this.currentImage.width;
      let height = this.currentImage.height;

      if (width > maxWidth || height > maxHeight) {
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        width *= ratio;
        height *= ratio;
      }

      canvas.width = width;
      canvas.height = height;

      // 绘制原始图片
      ctx.drawImage(this.currentImage, 0, 0, width, height);

      // 绘制所有水印
      this.markList.forEach(mark => {
        const patternCanvas = this.createWatermarkPattern(mark);

        ctx.save();

        // 设置全局透明度
        ctx.globalAlpha = mark.opacity / 100;

        if (mark.repeatMode === 'no-repeat') {
          // 对于不重复模式，直接绘制单个水印
          ctx.translate(mark.offsetX, mark.offsetY);

          const XOffset = (canvas.width / 2) - (patternCanvas.width / 2)
          const YOffset = (canvas.height / 2) - (patternCanvas.height / 2)

          ctx.drawImage( patternCanvas, XOffset, YOffset );
        } else {
          // 对于重复模式，使用图案填充
          const patternObj = ctx.createPattern(patternCanvas, mark.repeatMode);
          ctx.fillStyle = patternObj;

          let XOffsetTran = mark.offsetX
          let YOffsetTran = mark.offsetY

          if (mark.repeatMode === 'repeat') {
            let count = 10000
            while (count > 0) {
              if (XOffsetTran > patternCanvas.width) {
                XOffsetTran -= patternCanvas.width
              } else if (XOffsetTran < -patternCanvas.width) {
                XOffsetTran += patternCanvas.width
              } else if (YOffsetTran > patternCanvas.height) {
                YOffsetTran -= patternCanvas.height
              } else if (YOffsetTran < -patternCanvas.height) {
                YOffsetTran += patternCanvas.height
              } else {
                break
              }
              count--
            }
          }

          const XOffset = - width * 2
          const YOffset = - height * 2

          ctx.translate(XOffsetTran, YOffsetTran);
          ctx.fillRect(XOffset,  YOffset, 4 * width, 4 * height);
        }

        ctx.restore();
      });
    },

    startDrag(e) {
      if (!this.activeWatermark || !this.currentImage) return;

      this.isDragging = true;
      this.rect = this.$refs.canvas.getBoundingClientRect();
      this.dragStartX = e.clientX - this.rect.left;
      this.dragStartY = e.clientY - this.rect.top;
    },

    doDrag(e) {
      if (!this.isDragging || !this.activeWatermark) return;

      const rect = this.$refs.canvas.getBoundingClientRect();
      const currentX = e.clientX - rect.left;
      const currentY = e.clientY - rect.top;

      const scaleX = this.$refs.canvas.width / rect.width;
      const scaleY = this.$refs.canvas.height / rect.height;

      this.activeWatermark.offsetX += (currentX - this.dragStartX) * scaleX;
      this.activeWatermark.offsetY += (currentY - this.dragStartY) * scaleY;

      this.dragStartX = currentX;
      this.dragStartY = currentY;

      if (!this.renderPending) {
        this.renderPending = true;
        requestAnimationFrame(() => {
          this.renderCanvas();
          this.renderPending = false;
        });
      }
    },

    stopDrag() {
      this.isDragging = false;
      console.log(this.activeWatermark.offsetX, this.activeWatermark.offsetY)
    },

    handleWheel(e) {
      if (!this.activeWatermark) return;

      const delta = e.deltaY > 0 ? -1 : 1;
      const step = Math.max(1, Math.min(20, Math.floor(this.activeWatermark.fontSize / 20)));
      this.activeWatermark.fontSize = Math.max(5, Math.min(1000, this.activeWatermark.fontSize + delta * step));

      if (!this.renderPending) {
        this.renderPending = true;
        requestAnimationFrame(() => {
          this.renderCanvas();
          this.renderPending = false;
        });
      }
    },

    downloadImage() {
      if (!this.currentImage) {
        alert('请先上传图片');
        return;
      }

      const canvas = this.$refs.canvas;
      const link = document.createElement('a');
      link.download = 'watermarked-image.png';
      link.href = canvas.toDataURL('image/png');
      link.click();
    }
  }
};
</script>


<style lang="less" scoped>

.watermark-editor {
  font-family: 'Arial', sans-serif;
  background-color: #f5f5f5;
  padding: 15px;
  display: flex;

  .container {
    flex: 1;
    display: flex;
    gap: 20px;
    max-width: 95vw;
    margin: 0 auto;

    .control-panel {
      width: 300px;
      height: 90vh;
      overflow-Y: scroll;
      overflow-x: hidden;
      background-color: white;
      border-radius: 8px;
      padding: 20px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      display: flex;
      flex-direction: column;
      gap: 20px;

      .watermark-list {
        margin-bottom: 7px;

        .header {
          font-size: 16px;
          color: #333;
          margin-bottom: 10px;
        }

        button {
          background-color: #4285f4;
          color: white;
          border: none;
          border-radius: 4px;
          padding: 8px 8px;
          font-size: 15px;
          cursor: pointer;
          transition: background-color 0.2s;
          margin-bottom: 12px;
        }

        button:hover {
          background-color: #3367d6;
        }

        .list-container {
          max-height: 25vh;
          overflow-y: auto;

          .watermark-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 8px 12px;
            margin-bottom: 5px;
            background-color: white;
            border-radius: 4px;
            border: 1px solid #ddd;
            cursor: pointer;
            transition: all 0.2s;

            .text {
              flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 14px;
            }

            .delete {
              width: 20px;
              height: 20px;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #999;
              font-size: 18px;
              cursor: pointer;
              border-radius: 50%;
              transition: all 0.2s;
            }

            .copy {
              display: flex;
              align-items: center;

              img {
                margin-top: 3px;
                height: 22px;
              }
            }

            .delete:hover {
              color: #ff5252;
              background-color: #ffebee;
            }

          }

          .watermark-item:hover {
            background-color: #e9f0fd;
          }

          .watermark-item.active {
            border-color: #4285f4;
            background-color: #e9f0fd;
            box-shadow: 0 0 0 2px rgba(66, 133, 244, 0.2);
          }
        }
      }

      .control-group {
        display: flex;
        flex-direction: column;
        gap: 8px;

        .rotation-angle-input-box {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .icon {
            font-size: 25px;
            font-weight: bold;
            cursor: pointer;
          }

          .icon:hover {
            color: #4285f4;
          }
        }
      }
    }

    .right-panel {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 20px;

      .header {
        background-color: white;
        border-radius: 8px;
        padding: 15px;
        display: flex;
        align-items: center;
        gap: 15px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

        span {
          width: 150px;
          color: #4285f4;
          font-weight: bold;
        }

        button {
          width: 100px;
          background-color: #4285f4;
          color: white;
          border: none;
          border-radius: 4px;
          padding: 5px 7px;
          cursor: pointer;
          font-weight: 500;
          transition: background-color 0.2s;
        }

        button:hover {
          background-color: #3367d6;
        }

        .label {
          width: 100px;
        }

        .hint {
          font-size: 14px;
          color: #666;
          display: flex;
        }
      }
    }
  }
}

label {
  font-weight: bold;
  color: #555;
  font-size: 14px;
}

input, select, button {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  width: 100%;
}

select {
  background-color: white;
  cursor: pointer;
}

input[type="range"] {
  padding: 0;
}

input[type="color"] {
  padding: 3px;
  height: 40px;
  cursor: pointer;
}

.canvas-container {
  background-color: white;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  flex: 1;
  max-height: calc(100vh - 165px);
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  canvas {
    max-width: 99%;
    max-height: 99%;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: white;
    cursor: move;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  }
}

@media (max-width: 900px) {
  .container {
    flex-direction: column;
  }

  .control-panel {
    width: 100%;
  }

  .canvas-container {
    max-height: 500px;
  }
}

.font-family-container {
  display: flex;
  flex-direction: column;
  gap: 10px;

  .font-family-input-box {
    display: flex;
    gap: 10px;
    margin-top: 10px;

    input {
      flex: 1;
      padding: 8px;
      border: 1px solid #ddd;
      border-radius: 4px;
    }

    button {
      width: 100px;
      white-space: nowrap;
      padding: 8px 12px;
      background-color: #4285f4;
      color: white;
      border: none;
      border-radius: 4px;
      cursor: pointer;
      transition: background-color 0.2s;

      &:hover {
        background-color: #3367d6;
      }
    }
  }
}
</style>